<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gerenciamento das Emissões de DAM de Prestação de
                  Serviço para o Município.</span>
                <br />
                <span class="navigation">Nota Fiscal > Emissão de DAM</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <label style="font-weight: bold; font-size: 12px">Filtro Pesquisa:</label>
          <div class="row">
            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar id="dataIni" name="dataFim" v-model="dataIni" :showIcon="true" dateFormat="dd/mm/yy"
                  placeholder="Data Inicial" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
              </span>
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar id="dataFim" name="dataFim" v-model="dataFim" :showIcon="true" dateFormat="dd/mm/yy"
                  placeholder="Data Final" v-maska="'##/##/####'" />
              </span>
            </div>
            <div class="col-md-4 col-lg-1">
              <Button @click="pesquisar()" alt="Pesquisar" label="Pesquisar" type="button" class="p-button-primary mr-2"
                icon="pi pi-search" :disabled="loading" />
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <Button @click="showNotaDam()" alt="Pesquisar Por Nfse" label="Pesquisar Por Nfse" type="button"
                class="p-button-primary mr-2 p-button-success" icon="pi pi-search" :disabled="loading" />
              <label style="font-size: 12px" v-if="this.numeroNfsePesquisa">Filtro Nfse Número:
                {{ this.numeroNfsePesquisa }}</label>
              <label style="font-size: 12px" v-if="this.filtro">Filtro CPF/CNPJ/Nome Tomador:
                {{ this.filtro }}</label>
            </div>
          </div>

          <hr />
          <template v-if="displayDetalhe">
            <div class="row">
              <div class="container-fluid">
                <div class="row">
                  <Card style="width: 100%">
                    <template slot="title">Detalhamento DAM de Número
                      {{ this.declaracaoSelecionada.numero }}</template>
                    <template slot="content">
                      Data: {{ this.declaracaoSelecionada.dataFormatada }}
                      <br />
                    </template>
                  </Card>
                </div>
              </div>
              <div class="container-fluid">
                <div class="row">
                  <h4 class="panel-title" style="margin-top: 1px">
                    <span class="title">Notas Fiscais relacionadas ao DAM.</span>
                  </h4>
                </div>
              </div>
              <div class="container-fluid" style="padding-top: 5px">
                <div class="row">
                  <DataTable id="teste" :value="listNotasDeclaradas" :paginator="true" :rows="10" :key="1"
                    :autoLayout="true" style="min-width: 100%">
                    <Column headerStyle="width: 10%" field="tipo" header="Tipo" bodyStyle="text-align:right">
                    </Column>
                    <Column headerStyle="width: 10%" field="numero" header="Numero" bodyStyle="text-align:right">
                    </Column>
                    <Column headerStyle="width: 8em" field="dataEmissaoFormatada" header="Emissão"
                      bodyStyle="text-align:center">
                    </Column>
                    <Column headerStyle="width: 8em" field="dataGeracaoFormatada" header="Geração"
                      bodyStyle="text-align:center">
                    </Column>
                    <Column headerStyle="width: 10%" field="valorFormatado" header="Valor" bodyStyle="text-align:right">
                    </Column>
                    <Column headerStyle="width: 8%" field="aliquota" header="Alíquota" bodyStyle="text-align:right">
                    </Column>
                    <Column headerStyle="width: 8%" field="valorDeducaoFormatado" header="Desconto"
                      bodyStyle="text-align:right">
                    </Column>
                    <Column headerStyle="width: 10%" field="valorIssFormatado" header="Valor ISS"
                      bodyStyle="text-align:right">
                    </Column>
                    <Column field="tomador" header="Tomador"></Column>
                  </DataTable>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="displayRetificar">
            <div class="row">
              <div class="container-fluid">
                <div class="row">
                  <Card style="width: 100%">
                    <template slot="title">DAM de Número
                      {{ this.declaracaoSelecionada.numero }} Selecionado para
                      edição.</template>
                    <template slot="content">
                      Data: {{ this.declaracaoSelecionada.dataFormatada }}
                      <br />
                    </template>
                  </Card>
                </div>
              </div>
              <div class="container-fluid">
                <div class="row">
                  <h4 class="panel-title" style="margin-top: 1px">
                    <span class="title">Notas Fiscais relacionadas ao DAM.</span>
                  </h4>
                </div>
              </div>
              <div class="container-fluid">
                <div class="row">
                  <Button type="button" title="Remover Todos" class="p-button-primary mr-2 p-button-danger"
                    icon="pi pi-times" style="margin-right: 0.5em" @click="removerNotasDeclaracao()" :disabled="loading"
                    label="Remover Todos"></Button>
                </div>
              </div>
              <div class="container-fluid" style="padding-top: 5px">
                <div class="row">
                  <DataTable id="teste" :value="listNotasDeclaradas" :paginator="true" :rows="10" :key="1"
                    :autoLayout="true" style="min-width: 100%">
                    <Column headerStyle="width: 4em" header bodyStyle="text-align: center">
                      <template #body="slotProps">
                        <Button type="button" title="Remover" class="p-button-primary mr-2 p-button-danger"
                          icon="pi pi-times" style="margin-right: 0.5em" @click="removerNotaDeclaracao(slotProps.data)"
                          :disabled="loading"></Button>
                      </template>
                    </Column>
                    <Column headerStyle="width: 10%" field="numero" header="Numero" bodyStyle="text-align:right">
                    </Column>
                    <Column headerStyle="width: 8em" field="dataEmissaoFormatada" header="Emissão"
                      bodyStyle="text-align:center">
                    </Column>
                    <Column headerStyle="width: 8em" field="dataGeracaoFormatada" header="Geração"
                      bodyStyle="text-align:center">
                    </Column>
                    <Column headerStyle="width: 12%" field="valorFormatado" header="Valor" bodyStyle="text-align:right">
                    </Column>
                    <Column field="tomador" header="Tomador"></Column>
                  </DataTable>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="row pr-3 pl-3">
              <h4 class="panel-title">
                <span class="title">DAMS Gerados no período.</span>
              </h4>
              <DataTable :value="listDeclaracao" :paginator="true" :rows="10" class="p-datatable-responsive" :key="0"
                :autoLayout="true" style="min-width: 100%" :rowClass="rowClass" ref="dt1" :filters="filtersModel">
                <template #empty>
                  Nenhum DAM encontrado!
                </template>
                <Column headerStyle="width: 1%">
                  <template #body="slotProps">
                    <div class="dropdown">
                      <Button class="btn btn-primary" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
                        data-toggle="dropdown" title="Opções" aria-haspopup="true" aria-expanded="false" :disabled="slotProps.data.tipo === 'SIMPLIFICADA' && (!slotProps.data.dataEncerramento || slotProps.data.status === 'Cancelada')"></Button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="carregarDetalhamento(slotProps.data)"
                          v-if="slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA'">
                          <span class="pi pi-file mr-2" style="padding-right: 2vw"></span>Detalhamento DAM
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="impressaoDeclaracao(slotProps.data.id, slotProps.data.pago)"
                          v-if="slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA'">
                          <span class="pi pi-print mr-2" style="padding-right: 2vw"></span>Impressão Detalhamento
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="imprimirNotificacao(slotProps.data.id)" v-if="slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA' &&
                            slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim' &&
                            (slotProps.data.situacao === 'Notificado')
                          ">
                          <span class="pi pi-print mr-2" style="padding-right: 2vw"></span>Imprimir Notificação
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading" @click="
                          abrirDialogImpressao(
                            slotProps.data
                          )"
                          v-if="(slotProps.data.tipo === 'DAM_AVULSA' || slotProps.data.tipo === 'DAM_DEVEDOR_CONTUMAZ' || (slotProps.data.tipo === 'SIMPLIFICADA' && slotProps.data.dataEncerramento)) || (slotProps.data.tipo !== 'SIMPLIFICADA' && slotProps.data.dataEncerramento && !slotProps.data.dataVigenciaFinal && slotProps.data.semMovimento != 'Sim' && slotProps.data.idBolDebito === 'S')">
                          <span class="pi pi-print mr-2" style="padding-right: 2vw"></span>Impressão Boleto(s)
                        </button>
                        <div class="dropdown-divider" v-if="slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA' &&
                          !slotProps.data.dataEncerramento &&
                          !slotProps.data.dataVigenciaFinal
                        " />
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="carregarRetificacao(slotProps.data)" v-if="slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA' &&
                            slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim' &&
                            (slotProps.data.idBolDebito === 'S' || slotProps.data.idBolDebito === 'M')
                          ">
                          <span class="pi pi-replay mr-2" style="padding-right: 2vw"></span>Editar DAM
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="cancelarDeclaracao(slotProps.data.id)" v-if="slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA' &&
                            !slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal
                          ">
                          <span class="pi pi-times mr-2" style="padding-right: 2vw"></span>Cancelar
                        </button>
                        <button class="dropdown-item" type="button"
                          v-show="slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA' && slotProps.data.dataEncerramento && currentUser.usuario.idBolAdmin"
                          :disabled="loading || inativo" @click="openTransferirCalculoes(slotProps.data)">
                          <span class="pi pi-pencil mr-2" style="padding-right: 2vw"></span>Transferir Valores
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="imprimirAutoInfracao(slotProps.data.id)" v-if="slotProps.data.tipo !== 'DAM_AVULSA' && slotProps.data.tipo !== 'DAM_DEVEDOR_CONTUMAZ' && slotProps.data.tipo !== 'SIMPLIFICADA' &&
                            slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim' &&
                            (slotProps.data.situacao === 'Auto de Infração')
                          ">
                          <span class="pi pi-print mr-2" style="padding-right: 2vw"></span>Detalhes Auto de Infração
                        </button>
                        
                      </div>
                    </div>
                  </template>
                </Column>
                <Column headerStyle="width: 3%" field="numeroAno" header="Número DAM">

                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.numeroAno }}
                      <span v-if="slotProps.data.tipo === 'DAM_DEVEDOR_CONTUMAZ'" 
                        style="font-size: 10px; background-color: #007bff; color: white; padding: 1px 5px; border-radius: 3px; margin-left: 5px;">DAM Devedor Contumaz</span>
                      <span v-else-if="slotProps.data.tipo === 'DAM_AVULSA'" 
                        style="font-size: 10px; background-color: #007bff; color: white; padding: 1px 5px; border-radius: 3px; margin-left: 5px;">DAM Nota Avulsa</span>
                      <span v-else-if="slotProps.data.tipo === 'SIMPLIFICADA'" 
                        style="font-size: 10px; background-color: #007bff; color: white; padding: 1px 5px; border-radius: 3px; margin-left: 5px;">Declaração Simplificada</span>
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['numeroAno']" class="p-column-filter"
                      placeholder="Iniciando com" />
                  </template>
                </Column>
                <Column headerStyle="width: 3%" field="dataFormatada" header="Data">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.dataFormatada }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['dataFormatada']" class="p-column-filter"
                      placeholder="Iniciando com" />
                  </template>
                </Column>
                <Column headerStyle="width: 10%" field="situacaoDam" header="Status">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.situacaoDam }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['situacaoDam']" class="p-column-filter"
                      placeholder="Iniciando com" />
                  </template>
                </Column>
                <Column headerStyle="width: 3%" field="pago" header="Pago?">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.pago }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['pago']" class="p-column-filter"
                      placeholder="Iniciando com" />
                  </template>
                </Column>
                <Column headerStyle="width: 5%" field="valorPago" header="Valor Pago">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.valorPagoFormatado }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['valorPago']" class="p-column-filter"
                      placeholder="Iniciando com" />
                  </template>
                </Column>
                <template #footer>
                  <div style="text-align: right">
                    <Button icon="pi pi-external-link" label="Exportar para CSV" @click="exportCSVDt1($event)" />
                  </div>
                </template>
              </DataTable>
            </div>
          </template>
          <template v-if="!displayDetalhe">
            <h4 class="panel-title">
              <span class="title" v-if="!displayRetificar">Notas Fiscais em Aberto para Emissão do DAM.</span>
              <span class="title" v-if="displayRetificar">Adicione abaixo novas notas ao DAM.</span>
            </h4>
            <hr />
            <Checkbox v-model="checkTodos" :binary="true" @change="selecionarTodos()" />
            <span style="padding-left: 5px; font-weight: bold; font-size: 12px">Selecionar Todos</span>
            <div style="padding-top: 10px">
              <DataTable :value="listNotas" :filters.sync="filters" :paginator="true" :rows="10" :autoLayout="true"
                style="min-width: 100%" ref="dt2">
                <template #header>
                  <div style="text-align: center">
                    <InputText v-model="filters['global']" placeholder="Filtrar" style="width: 50%; min-width: 300px" />
                    <i class="pi pi-search" style="margin: 4px 4px 0px 0px"></i>
                  </div>
                </template>
                <Column headerStyle="width: 3%" field="selecionado" header>
                  <template #body="slotProps">
                    <Checkbox v-model="slotProps.data.selecionado" :binary="true" />
                  </template>
                </Column>
                <Column headerStyle="width: 10%" field="numero" header="Número" bodyStyle="text-align:right"></Column>
                <Column headerStyle="width: 8em" field="competenciaFormatada" header="Competência"
                  bodyStyle="text-align:center">
                </Column>
                <Column headerStyle="width: 8em" field="dataGeracaoFormatada" header="Geração"
                  bodyStyle="text-align:center"></Column>
                <Column headerStyle="width: 10em" field="valorFormatado" header="Valor" bodyStyle="text-align:right">
                </Column>
                <Column headerStyle="width: 10em" field="valorDeducaoFormatado" header="Dedução"
                  bodyStyle="text-align:right"></Column>
                <Column headerStyle="width: 8em" field="aliquota" header="Alíquota" bodyStyle="text-align:right">
                </Column>
                <Column headerStyle="width: 10em" field="valorIssFormatado" header="Valor Iss"
                  bodyStyle="text-align:right">
                </Column>
                <Column field="tomador" header="Tomador"></Column>
                <Column headerStyle="width: 6em" field="situacao" header="Situação" bodyStyle="text-align:center">
                </Column>
                <template #footer>
                  <div style="text-align: right">
                    <Button icon="pi pi-external-link" label="Exportar para CSV" @click="exportCSVDt2($event)" />
                  </div>
                </template>
              </DataTable>
            </div>
          </template>
          <hr />
          <template v-if="(!displayRetificar && !displayDetalhe)">
            <Button @click="gerarDAM()" alt="Gerar DAM" label="Gerar DAM" type="button"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
          </template>
          <template v-else-if="displayRetificar">
            <Button @click="adicionarNotasDeclaracao()" label="Adicionar" type="button" class="p-button-primary mr-2"
              icon="pi pi-check" :disabled="loading" />
            <hr />
            <Button @click="editarDam()" label="Editar DAM" type="button" class="p-button-primary mr-2 p-button-success"
              icon="pi pi-replay" :disabled="loading" />
            <Button @click="hideRetificar()" label="Cancelar" type="button"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" :disabled="loading" />
          </template>
          <template v-else-if="displayDetalhe">
            <Button @click="hideDetalhe()" label="Voltar" type="button" class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-arrow-left" :disabled="loading" />
          </template>
        </div>
      </div>
    </div>
    <Dialog header="Competência" :visible.sync="showSelectComp" :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Competência
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showSelectComp = false" />
      </h1><br />
      <span class="p-fluid">
        <Dropdown id="filtroAno" v-model="filtroAno" :options="listAnos" optionLabel="name"
          placeholder="Selecione um Ano" />
      </span>
      <span class="p-fluid">
        <Dropdown id="filtroMes" v-model="filtroMes" :options="listMeses" optionLabel="name"
          placeholder="Selecione um Mês" />
      </span>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Selecionar" icon="pi pi-check" @click="pesquisar()" :disabled="loading" class="mr-2"/>
            <Button label="Fechar" icon="pi pi-times" @click="fecharSelectCompetencia()" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Aviso" :visible.sync="displayDecSemMov" :style="{ width: '30vw' }" :modal="true">
      Confirma realizar o DAM sem Movimento para Competência?
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Sim" icon="pi pi-check" @click="declararSemMovimento()" :disabled="loading" class="mr-2"/>
            <Button label="Não" icon="pi pi-times" @click="hideDecSemMov()" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Imprimir Boleto" :visible.sync="displayVencBoleto" :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Imprimir Boleto
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayVencBoleto = false" />
      </h1><br />
      <div class="col-md-8 mb-8">
        <label for="dataVencBoleto">Data de Vencimento: *</label>
        <span class="p-fluid">
          <Calendar :key="keyVencBoleto" id="dataVencBoleto" name="dataVencBoleto" v-model="dataVencimento"
            :showIcon="true" dateFormat="dd/mm/yy" />
        </span>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Sim" icon="pi pi-check" @click="imprimirBoleto()" v-if="tipoEmissaoBoleto === 'N'"
              :disabled="loading" class="mr-2"/>
            <Button label="Sim" icon="pi pi-check" @click="imprimirBoletoPix()" v-if="tipoEmissaoBoleto === 'P'"
              :disabled="loading" class="mr-2"/>
            <Button label="Não" icon="pi pi-times" @click="hideVencBoleto()" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog
      :visible.sync="displayVencDamAvulso"
      :style="{ width: '42vw' }"
      :contentStyle="{ overflow: 'visible' }"
      :modal="true"
    >
      <h1 class="titulo-header">
        {{ tipoDamSelecionado === 'DAM_AVULSA' ? 'DAM Nota Avulsa' : 'DAM Devedor Contumaz' }}
        <Button
          id="icon-close-modals"
          icon="pi pi-times"
          class="p-button-rounded p-button-text"
          @click="displayVencDamAvulso = false"
        />
      </h1>
      <br />
      <div class="col-md-4 mb-8">
        <label for="dataVencDamAvulso">Data de Vencimento: *</label>
        <span class="p-fluid">
          <Calendar
            :key="keyVencDamAvulso"
            id="dataVencDamAvulso"
            name="dataVencDamAvulso"
            v-model="dataVencimento"
            :showIcon="true"
            dateFormat="dd/mm/yy"
          />
        </span>
      </div>
      <hr />
      <div>
        <div class="row ml-2 mb-2">
            <Button
              label="Imprimir Boleto"
              icon="pi pi-print"
              @click="imprimirBoletoDamAvulso()"
              :disabled="loading"
              class="mr-2"
            />
        </div>
        <div v-if="habilitarPix" class="row ml-2 mb-2">
            <Button
              type="button"
              label="Pagar com PIX"
              title="Pagar com PIX"
              class="p-button-outlined mr-2"
              icon="pi pix-icon"
              style="margin-right: 0.5em"
              :disabled="loading"
              @click="criarPagamentoPixDamAvulso()"
            ></Button>
            <Button
              label="Imprimir DAM PIX"
              class="p-button-outlined mr-2"
              icon="pi pix-icon"
              @click="imprimirBoletoPixDamAvulso()"
              :disabled="loading"
            />
            <Button
              title="Consultar Pagamento PIX"
              label="Consultar Pagamento PIX"
              icon="pi pi-search"
              style="margin-right: 0.5em"
              @click="consultarPagamentoPixDamAvulso()"
              class="mr-2"
            />
        </div>
        <div class="row ml-2 mt-3">
          <Button label="Fechar" icon="pi pi-times" @click="displayVencDamAvulso = false" class="p-button-secondary" />
        </div>
      </div>
    </Dialog>
    <Dialog header="Boleto" :visible.sync="displayBoletos" :style="{ width: '35vw' }" :modal="true">
      <h1 class="titulo-header">
        Boleto
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayBoletos = false" />
      </h1><br />
      <DataTable :value="listBoletos" :paginator="true" :rows="10" :autoLayout="true" style="min-width: 100%">
        <Column headerStyle="width: 2.5em" header bodyStyle="text-align: center">
          <template #body="slotProps">
            <Button type="button" title="Imprimir Boleto" class="p-button-primary mr-2" icon="pi pi-print"
              style="margin-right: 0.5em" @click="
                carregarVencimentoBoleto(
                  slotProps.data.id,
                  slotProps.data.tipo,
                  slotProps.data.dataVencimento,
                  'N'
                )
                " :disabled="loading" v-if="slotProps.data.pagamentoEfetuado == 'N'"></Button>
            <Button type="button" title="Pagar com PIX" class="p-button-outlined mr-2" icon="pi pix-icon"
              style="margin-right: 0.5em" @click="
                escolhaPagamentoPix(
                  slotProps.data.id,
                  slotProps.data.tipo,
                  slotProps.data.dataVencimento
                )
                " :disabled="loading" v-if="slotProps.data.pagamentoEfetuado == 'N' && habilitarPix"></Button>
            <Button title="Consultar Pagamento PIX" icon="pi pi-search" style="margin-right: 0.5em"
              @click="consultarPagamentoPix(slotProps.data.id)"
              v-if="slotProps.data.pagamentoEfetuado == 'N' && habilitarPix" />
          </template>
        </Column>
        <Column headerStyle="width: 10%" field="vencimentoFormatado" header="Vencimento" bodyStyle="text-align:right">
        </Column>
        <Column headerStyle="width: 8em" field="valorFormatado" header="Valor" bodyStyle="text-align:center"></Column>
      </DataTable>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="hideBoletos()" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="showEscolhaPix" :style="{ width: '30vw' }" :contentStyle="{ overflow: 'visible' }"
      :modal="true">
      <template #header>
        <Button class="p-button-outlined mr-2" icon="pi pix-icon" />
        <h3>Pagar com PIX</h3>
      </template>
      <div class="col-md-8 mb-8">
        <Button label="QR Code" icon="pi pi-bars" @click="criarPagamentoPix()" style="margin-right: 0.5em"
          :disabled="loading" />
        <Button label="Boleto" icon="pi pi-print" @click="
          carregarVencimentoBoleto(
            idDamAgrupamento,
            tipoDam,
            dataVencimento,
            'P'
          )
          " :disabled="loading" />
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="showEscolhaPix = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="showPix" :style="{ width: '40vw' }" :modal="true">
      <template #header>
        <Button class="p-button-outlined mr-2" icon="pi pix-icon" />
        <h3>Pagar com PIX</h3>
      </template>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 mb-2">
            <QRCanvas :options="optionsPix" />
          </div>
          <div class="col-md-6 mb-2">
            <div style="padding-top: 20px">
              Utilize o App de sua Instituição Financeira, na opção PIX escolha
              pagar com QR Code, confirme os dados e realize o Pagamento. <br />
              <br /><span style="font-weight: bold">Valor Total:
                {{ this.pixGerado ? this.pixGerado.valorFormatado : 0 }}</span>
            </div>
          </div>
        </div>
      </div>

      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="showPix = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Aplicar desconto em Valores Declarados" :visible.sync="displayItensDecBeneficio"
      :style="{ width: '40vw' }" :modal="true">
      <h1 class="titulo-header">
        Aplicar desconto em Valores Declarados
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayItensDecBeneficio = false" />
      </h1><br />
      <DataTable :value="listItensDeclaracao" :paginator="true" :rows="10" :autoLayout="true" style="min-width: 100%">
        <Column headerStyle="width: 8em" field="valorFormatado" header="Valor" bodyStyle="text-align:center"></Column>
        <Column headerStyle="width: 8em" field="aliquotaFormatado" header="Alíquota" bodyStyle="text-align:center">
        </Column>
        <Column headerStyle="width: 8em" field="abatimentoFormatado" header="Desconto" bodyStyle="text-align:center">
          <template #body="slotProps">
            <money id="abatimento" name="abatimento" v-model="slotProps.data.abatimento" v-bind="money"
              class="p-inputtext input-right"></money>
          </template>
        </Column>
        <Column headerStyle="width: 8em" field="valorIssFormatado" header="ISS" bodyStyle="text-align:center">
          <template #body="slotProps">
            {{
              getTotalIss(
                slotProps.data.valor,
                slotProps.data.abatimento,
                slotProps.data.aliquota
              )
            }}
          </template>
        </Column>
      </DataTable>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button @click="encerrarDeclaracaoBeneficio()" label="Emitir DAM" type="button"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
            <Button label="Fechar" icon="pi pi-times" @click="hideItensDecbeneficio()" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Pesquisar DAM por Nfse" :visible.sync="showPesqNota" :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Pesquisar DAM por Nfse
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showPesqNota = false" />
      </h1><br />
      <span class="p-fluid">
        <InputText v-model="numeroNfsePesquisa" placeholder="Número Nfse" />
      </span>
      <span class="p-fluid">
        <InputText v-model="filtro" placeholder="CPF/CNPJ/Nome Tomador" />
      </span>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Pesquisar" icon="pi pi-check" @click="pesquisarDamPorNota()" :disabled="loading" class="mr-2"/>
            <Button label="Fechar" icon="pi pi-times" @click="showPesqNota = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Transferência de Valores" :visible.sync="showTransfValores" :style="{ width: '30vw' }" :modal="true"
      v-if="declaracaoSelecionada">
      <h1 class="titulo-header">
        Transferência de Valores
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showTransfValores = false" />
      </h1><br />
      DAM Selecionado: {{ declaracaoSelecionada.numero }}<br /><br />
      ATENÇÃO! Essa opção deve ser utilizada para transferir os calculos/valores do dam selecionado para outro,
      nos casos onde há pagamento em dams canceladas/retificados e pagos.
      caso confirme a operação informe abaixo o numero do dam de destino
      <hr />
      <span class="p-fluid">
        <InputText v-model="numeroDeclaracaoDestino" placeholder="Número DAM Destino" />
      </span>
      <hr/>
      <div class="container">
        <div class="row">
          <div>
            <Button label="Transferir" icon="pi pi-check" @click="transferirCalculos()" class="mr-2"/>
            <Button label="Fechar" icon="pi pi-times" @click="showTransfValores = false" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog 
      :visible.sync="showAutoInfracao"
      :style="{ width: '40vw' }"
      :modal="true"
    >
    <h1 class="titulo-header">Auto de Infração</h1>
    <hr/>
      <div style="padding: 1.5rem;">
        <small class="subtitle">Referente ao Auto de Infração de Número:</small>
        <div class="text-center mt-3">
          <input 
            v-model="dadosAutoInfracao"
            disabled
            class="p-inputtext custom-input"
          />
        </div>
        <hr class="custom-divider" style="margin: 1.5rem 0;" />
        <div class="flex justify-content-center">
          <Button 
            label="Fechar" 
            icon="pi pi-times" 
            @click="showAutoInfracao = false"
            class="p-button-danger"
          />
        </div>
      </div>
    </Dialog>
    <BlockUI :blocked="bloquearTela" fullScreen />
  </div>
</template>
<script>
import money from "../conf/config.money";
import DeclaracaoService from "../services/tributario/declaracao.service";
import LoginService from "../services/acesso/login.service";
import ReportService from "../services/report.service";
import NotaDeclaracaoEdicao from "../models/tributario/NotaDeclaracaoEdicao";
import { QRCanvas } from "qrcanvas-vue";
import CustomCalendar from "../components/global/CustomCalendar.vue";
import GpiService from "../services/nfse/gpi.service";
import NotaFiscalAvulsaService from "../services/nfse/notafiscalavulsa.service";

export default {
  name: "declaracaoNormal",
  components: {
    QRCanvas,CustomCalendar
  },
  data() {
    return {
      money: money,
      keyVenc: 0,
      keyVencBoleto: 1,
      keyVencDamAvulso: 1,
      displayVencDamAvulso: false,
      tipoDamSelecionado: null,
      idNotaAvulsaSelecionada: null,
      competencia: "",
      inativo: false,
      checkTodos: false,
      loading: false,
      dataIni: null,
      dataFim: null,
      listAnos: [],
      listMeses: [],
      listDeclaracao: [],
      listItensDeclaracao: [],
      displayItensDecBeneficio: false,
      listNotas: [],
      filters: {},
      currentUser: null,
      competenciaLimite: null,
      showSelectComp: false,
      displayDecSemMov: false,
      showImpressaoBoletos: false,
      idDeclaracaoSelecionada: null,
      dataVencimento: null,
      listNotasDeclaradas: [],
      declaracaoSelecionada: null,
      displayRetificar: false,
      displayDetalhe: false,
      displayBoletos: false,
      listBoletos: [],
      idDecLancamentoSelecionado: null,
      tipoDam: null,
      tipoEmissaoBoleto: "N",
      idDamAgrupamento: null,
      displayVencBoleto: false,
      habilitarPix: false,
      showEscolhaPix: false,
      showPix: false,
      optionsPix: {
        cellSize: 5,
        data: "hello",
      },
      pixGerado: null,
      numeroNfsePesquisa: '',
      showPesqNota: false,
      notaDeclaracaoEdicao: null,
      filtro: '',
      filtersModel: {},
      numeroDeclaracaoDestino: null,
      showTransfValores: false,
      bloquearTela: false,
      sqlRelatorio: null,
      showAutoInfracao: false,
      dadosAutoInfracao: null
    };
  },

  created() {
    this.dataIni = this.subtractMonths(new Date(), 2);
    this.dataFim = new Date();
    this.competenciaLimite = new Date();
    this.competenciaLimite.setMonth(this.competenciaLimite.getMonth());
    this.currentUser = LoginService.currentUserValue;
    this.habilitarPix = this.currentUser.configuracao.idBolUtilizarPix === "S";
    this.inativo =
      this.currentUser && this.currentUser.contribuinte
        ? !this.currentUser.contribuinte.ativo
        : false;
    this.carregarAnos();
    this.carregarMeses();
    this.carregarCompetenciaAtual();
    this.pesquisar();
  },

  methods: {
    async imprimirNotificacao(idDeclaracao) {
      this.processando(true);

      try {
        let idCalculoParcelado = null;
        await DeclaracaoService.obterCalculoDeclaracao(idDeclaracao).then(
          (response) => {
            idCalculoParcelado = response.data;
          },
          (error) => {
            this.$root.$emit("alert:warn", error.response.data);
            return;
          }
        );
        await GpiService.imprimirNotificacao(this.currentUser.usuario.idCliente, idCalculoParcelado);
      } catch (error) {
        if (error.response && error.response.status === 400) {
          const e = await error.response.data.text();
          try {
            const outer = JSON.parse(e);
            const inner = JSON.parse(outer.message);
            this.$root.$emit("alert:warn", inner.message || "Erro desconhecido");

          } catch (e) {
            this.$root.$emit("alert:warn", e);
          }
        } else {
          this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
        }
      }
      this.processando(false);
    },
    imprimirAutoInfracao(idDeclaracao){
      DeclaracaoService.obterDadosAutoInfracao(idDeclaracao).then(
        data =>{
          this.dadosAutoInfracao = data.data;
          console.log(data);
        },
        error => {
          console.log(error);
        }
      )
      this.showAutoInfracao = true;
    },
    rowClass(data) {
      if (data.tipo === "DAM_AVULSA" || data.tipo === "DAM_DEVEDOR_CONTUMAZ") {
        return data.pago !== "Sim" ? "green-row" : null;
      }
      return data.status === "Cancelada" || data.status === "Retificada"
        ? "red-row"
        : data.status === "Encerrada"
          ? "green-row"
          : null;
    },
    lineClass(data) {
      if (data.tipo === "DAM_AVULSA" || data.tipo === "DAM_DEVEDOR_CONTUMAZ") {
        return data.pago !== "Sim" ? "white-line" : null;
      }
      return data.status === "Cancelada" ||
        data.status === "Retificada" ||
        data.status === "Encerrada"
        ? "white-line"
        : null;
    },
    rolarPagina() {
      document.getElementById("topo").scrollIntoView({
        behavior: "smooth",
      });
    },

    subtractMonths(date, months) {
      const dateCopy = new Date(date);
      dateCopy.setMonth(dateCopy.getMonth() - months);
      return dateCopy;
    },
    alterarCompetencia() {
      this.showSelectComp = true;
    },
    fecharSelectCompetencia() {
      this.showSelectComp = false;
    },
    pesquisar() {
      this.numeroNfsePesquisa = '';
      this.filtro = '';
      this.processando(true);

      let novaCompetencia =
        this.filtroAno.key +
        "" +
        this.formatted_string("00", this.filtroMes.key, "l");
      let compMax =
        this.competenciaLimite.getFullYear() +
        "" +
        this.formatted_string("00", this.competenciaLimite.getMonth() + 1, "l");

      if (parseInt(novaCompetencia) > parseInt(compMax)) {
        this.$root.$emit("alert:warn", "Competência ainda não disponivel!");
        this.processando(false);
        return;
      }

      this.competencia = this.filtroMes.name + "/" + this.filtroAno.key;
      DeclaracaoService.findAllDeclaracoesPorPeriodo(
        this.currentUser.contribuinte.idContribuinte,
        this.dataIni,
        this.dataFim
      ).then((response) => {
        this.listDeclaracao = response.data;
        console.log(response.data);
      });

      DeclaracaoService.findAllNotasEmAbertoPorPeriodo(
        this.currentUser.contribuinte.idContribuinte,
        this.dataIni,
        this.dataFim
      )
        .then((responseNota) => {
          this.listNotas = responseNota.data;
        })
        .then(() => {
          this.showSelectComp = false;
          this.processando(false);
        });
    },
    processando(show, block = false) {
      if (show) {
        this.loading = true;
        this.bloquearTela = block;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.bloquearTela = false;
        this.$root.$emit("loading:hide");
      }
    },
    carregarItensBeneficio(idDeclaracao) {
      DeclaracaoService.findAllItensDeclaracao(idDeclaracao).then(
        (response) => {
          this.listItensDeclaracao = response.data;
          this.displayItensDecBeneficio = true;
        }
      );
    },
    carregarAnos() {
      let ano = this.competenciaLimite.getFullYear();
      // eslint-disable-next-line
      for (var i = ano; i > ano - 10; i--) {
        this.listAnos.push({ name: i, key: i });
      }
    },
    carregarMeses() {
      this.listMeses.push({ name: "Janeiro", key: 1 });
      this.listMeses.push({ name: "Fevereiro", key: 2 });
      this.listMeses.push({ name: "Março", key: 3 });
      this.listMeses.push({ name: "Abril", key: 4 });
      this.listMeses.push({ name: "Maio", key: 5 });
      this.listMeses.push({ name: "Junho", key: 6 });
      this.listMeses.push({ name: "Julho", key: 7 });
      this.listMeses.push({ name: "Agosto", key: 8 });
      this.listMeses.push({ name: "Setembro", key: 9 });
      this.listMeses.push({ name: "Outubro", key: 10 });
      this.listMeses.push({ name: "Novembro", key: 11 });
      this.listMeses.push({ name: "Dezembro", key: 12 });
    },
    carregarCompetenciaAtual() {
      let ano = this.competenciaLimite.getFullYear();
      let mes = this.competenciaLimite.getMonth();
      mes = mes + 1;

      this.filtroAno = this.listAnos.filter((local) => local.key == ano)[0];
      this.filtroMes = this.listMeses.filter((local) => local.key == mes)[0];
      this.competencia = this.filtroMes.name + "/" + ano;
    },
    selecionarTodos() {
      if (this.checkTodos) {
        this.listNotas.forEach(function (value) {
          value.selecionado = true;
        });
      } else {
        this.listNotas.forEach(function (value) {
          value.selecionado = false;
        });
      }
    },
    gerarDAM() {
      if (
        (!this.listNotas || this.listNotas.length <= 0)
      ) {
        this.$root.$emit(
          "alert:warn",
          "Selecione ao menos uma nota para gerar o DAM!"
        );
        return;
      }
      let checked = false;
      this.listNotas.forEach(function (value) {
        if (value.selecionado) {
          checked = true;
          return;
        }
      });
      if (!checked) {
        this.$root.$emit(
          "alert:warn",
          "Selecione ao menos uma nota para gerar o DAM!"
        );
      } else {
        this.processando(true, true);
        this.gerarDAMNotas();
      }
    },
    confirmaDeclararSemMovimento() {
      this.processando(false);
      this.displayDecSemMov = true;
    },
    hideDecSemMov() {
      this.displayDecSemMov = false;
    },
    declararSemMovimento() {
      DeclaracaoService.declararSemMov(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key
      ).then((response) => {
        console.log(response);
        this.pesquisar();
        this.$root.$emit(
          "alert:success",
          "DAM sem Movimento gerado com sucesso!"
        );
      });
      this.displayDecSemMov = false;
    },
    gerarDAMNotas() {
      this.processando(true, true);
      let listNotasSelecionadas = [];
      this.listNotas.forEach(function (value) {
        if (value.selecionado) {
          listNotasSelecionadas.push(value);
        }
      });

      this.rolarPagina();
      
      DeclaracaoService.gerarDam(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key,
        "N",
        listNotasSelecionadas
      ).then(
        (response) => {
          console.log(response);
          this.pesquisar();
          this.$root.$emit("alert:success", "DAM gerado com sucesso!");
        },
        (error) => {
          console.log(error);
          this.$root.$emit("alert:error", error.response.data);
        }
      ).then(() => {
        this.processando(false);
      });
    },
    cancelarDeclaracao(idDeclaracao) {
      this.processando(true);
      DeclaracaoService.cancelar(
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        idDeclaracao
      )
        .then((response) => {
          console.log(response);
          this.pesquisar();
          this.$root.$emit(
            "alert:success",
            "DAM cancelado com sucesso!"
          );
        })
        .then(() => {
          this.processando(false);
        });
    },
    openTransferirCalculoes(declaracao) {
      this.declaracaoSelecionada = declaracao;
      this.idDeclaracaoSelecionada = declaracao.id;
      this.showTransfValores = true;
      this.numeroDeclaracaoDestino = null;
    },
    transferirCalculos() {
      this.processando(true);
      DeclaracaoService.transferirCalculosDeclaracao(
        this.idDeclaracaoSelecionada,
        this.numeroDeclaracaoDestino
      )
        .then((response) => {
          console.log(response);
          this.pesquisar();
          this.showTransfValores = false;
          this.$root.$emit(
            "alert:success",
            "Transferência realizada com sucesso!"
          );
        },
          (error) => {
            console.log(error);
            this.$root.$emit("alert:warn", error.response.data);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    encerrarDeclaracaoBeneficio() {
      this.processando(true);
      DeclaracaoService.encerrarComBeneficio(
        this.currentUser.usuario.idUsuario,
        this.listItensDeclaracao
      )
        .then(
          (response) => {
            console.log(response);
            this.pesquisar();
            this.$root.$emit(
              "alert:success",
              "DAM gerado com sucesso!"
            );
          },
          (error) => {
            console.log(error);
            this.$root.$emit("alert:error", error.response.data);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    encerrarDeclaracao(id) {
      this.idDeclaracaoSelecionada = id;
      this.processando(true);
      DeclaracaoService.encerrar(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.idDeclaracaoSelecionada
      )
        .then(
          (response) => {
            console.log(response);
            if (response.data === "BG") {
              this.carregarItensBeneficio(this.idDeclaracaoSelecionada);
            } else {
              this.pesquisar();
              this.$root.$emit(
                "alert:success",
                "DAM gerado com sucesso!"
              );
            }
          },
          (error) => {
            console.log(error);
            this.$root.$emit(
              "alert:error",
              "Não foi possível gerar o DAM, verifique com o administrador do sistema se o Serviço de Geração de DAM esta disponível!"
            );
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    carregarDetalhamento(declaracao) {
      this.processando(true);
      this.declaracaoSelecionada = declaracao;
      DeclaracaoService.carregarNotasDeclaracao(this.declaracaoSelecionada.id)
        .then((response) => {
          this.listNotasDeclaradas = response.data;
          this.displayDetalhe = true;
        })
        .then(() => {
          this.processando(false);
        });
    },
    carregarRetificacao(declaracao) {
      this.processando(true);
      this.declaracaoSelecionada = declaracao;
      DeclaracaoService.competenciaDamEmFiscalizacao(this.declaracaoSelecionada.id)
        .then((responseFisc) => {
          console.log(responseFisc);
          if (responseFisc.data === 'S') {
            this.$root.$emit(
              "alert:warn",
              "Não sera possível Editar o DAM, Contribuinte em processo de Fiscalização para um dos períodos do DAM!"
            );
            this.processando(false);
            return;
          }
          DeclaracaoService.carregarNotasDeclaracao(this.declaracaoSelecionada.id)
            .then((response) => {
              console.log(response);
              this.listNotasDeclaradas = response.data;
              this.displayRetificar = true;
            })
            .then(() => {
              this.processando(false);
            });
        })
    },
    hideRetificar() {
      this.processando(true);
      this.declaracaoSelecionada = null;
      this.displayRetificar = false;
      this.pesquisar();
      this.rolarPagina();
      this.processando(false);
    },
    hideDetalhe() {
      this.processando(true);
      this.declaracaoSelecionada = null;
      this.displayDetalhe = false;
      this.pesquisar();
      this.rolarPagina();
      this.processando(false);
    },
    adicionarNotasDeclaracao() {
      this.processando(true);
      for (let i = this.listNotas.length - 1; i >= 0; i--) {
        if (this.listNotas[i].selecionado) {
          this.listNotasDeclaradas.push(this.listNotas[i]);
          this.listNotas.splice(i, 1);
        }
      }
      this.listNotasDeclaradas.sort(function (a, b) {
        return parseFloat(b.numero) - parseFloat(a.numero);
      });
      this.rolarPagina();
      this.processando(false);
    },
    removerNotaDeclaracao(notaDec) {
      this.processando(true);
      notaDec.selecionado = false;
      this.listNotas.push(notaDec);
      this.listNotasDeclaradas.forEach(function (item, index, object) {
        if (item.id === notaDec.id) {
          object.splice(index, 1);
        }
      });
      this.listNotas.sort(function (a, b) {
        return parseFloat(b.numero) - parseFloat(a.numero);
      });
      this.rolarPagina();
      this.processando(false);
    },
    removerNotasDeclaracao() {
      this.processando(true);
      let newList = this.listNotas.slice();
      this.listNotasDeclaradas.forEach(function (item) {
        newList.push(item);
      });
      this.listNotas = newList;
      this.listNotasDeclaradas = [];
      this.listNotas.sort(function (a, b) {
        return parseFloat(b.numero) - parseFloat(a.numero);
      });
      this.rolarPagina();
      this.processando(false);
    },
    editarDam() {
      this.processando(true);
      this.notaDeclaracaoEdicao = new NotaDeclaracaoEdicao();
      this.notaDeclaracaoEdicao.notasFiscaisDam = this.listNotasDeclaradas;
      this.notaDeclaracaoEdicao.notasFiscaisSemDam = this.listNotas;
      DeclaracaoService.editarDam(
        this.currentUser.usuario.idUsuario,
        this.declaracaoSelecionada.id,
        this.notaDeclaracaoEdicao
      )
        .then((response) => {
          console.log(response);
          this.pesquisar();
          this.$root.$emit(
            "alert:success",
            "DAM editado com sucesso!"
          );
          this.hideRetificar();
        },
          (error) => {
            console.log(error);
            let erro = "";
            if (error.response && error.response.data) {
              erro = error.response.data;
            }
            this.$root.$emit(
              "alert:error",
              erro
            );
          })
        .then(() => {
          this.processando(false);
        });
    },
    impressaoDeclaracao(id, pago) {
      this.processando(true);
      ReportService.imprimir("DetalhamentoDAM", [
        {
          param: "ID",
          string: id,
        },
        {
          param: "TIPO",
          string: "N",
        },
        {
          param: "PAGO",
          string: pago,
        },
      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit(
              "alert:warn",
              "Erro ao imprimir Detalhamento DAM!"
            );
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    abrirDialogImpressao(data) {
      if (data.tipo === 'DAM_AVULSA' || data.tipo === 'DAM_DEVEDOR_CONTUMAZ') {
        if (data.pago === 'Sim' && !this.currentUser.usuario.idBolAdmin) {
          this.$root.$emit('alert:warn', 'Não é possível imprimir um Boleto Pago!');
          return;
        }
        this.idNotaAvulsaSelecionada = data.id.replace('DAM_', '');
        this.tipoDamSelecionado = data.tipo;
        
        let novaData = new Date();
        this.dataVencimento = novaData;
        this.displayVencDamAvulso = true;
      } else {
        this.impressaoBoletos(data.id, data.pago);
      }
    },
    imprimirBoletoDamAvulso() {
      if (!this.dataVencimento) {
        this.$root.$emit('alert:warn', 'Data de Vencimento Obrigatória!');
        return;
      }
      this.processando(true);
      NotaFiscalAvulsaService.atualizarVencimento(this.idNotaAvulsaSelecionada, this.dataVencimento)
        .then(
          (response) => {
            let idGerado = response.data;
            ReportService.imprimir('trb_dam_a5', [
              {
                param: 'RP_ID_CLIENTE',
                string: this.currentUser.usuario.idCliente,
              },
              {
                param: 'P_CONTROLE_PARCELA',
                string: " and cp.id_situacao in('1','4','6')  and  cp.id in ('" + idGerado + "')",
              },
            ]).then(
              () => {
                this.processando(false);
              },
              (error) => {
                this.processando(false);
                this.$root.$emit('alert:warn', 'Erro ao exibir a visualização!');
                console.log(error);
              },
            );
          },
          (error) => {
            this.processando(false);
            this.$root.$emit('alert:warn', 'Erro ao atualizar Vencimento!');
            console.log(error);
          },
        )
    },
    criarPagamentoPixDamAvulso() {
      this.processando(true);
      NotaFiscalAvulsaService.criarPagamentoPix(this.idNotaAvulsaSelecionada).then(
        (response) => {
          this.pixGerado = response.data;
          this.showPix = true;
          this.processando(false);
        },
        (error) => {
          this.processando(false);
          this.$root.$emit('alert:warn', 'Erro ao gerar PIX!');
          console.log(error);
        }
      );
    },
    imprimirBoletoPixDamAvulso() {
      if (!this.dataVencimento) {
        this.$root.$emit('alert:warn', 'Data de Vencimento Obrigatória!');
        return;
      }
      this.processando(true);
      NotaFiscalAvulsaService.atualizarVencimento(this.idNotaAvulsaSelecionada, this.dataVencimento)
        .then(
          (response) => {
            let idGerado = response.data;
            NotaFiscalAvulsaService.criarPagamentoPixCp(this.idNotaAvulsaSelecionada, idGerado).then(
              (response) => {
                this.pixGerado = response.data;
                ReportService.imprimir('trb_dam_a5_pix', [
                  {
                    param: 'RP_ID_CLIENTE',
                    string: this.currentUser.usuario.idCliente,
                  },
                  {
                      param: 'QR_CODE',
                      string: this.pixGerado.qrCode,
                    },
                  {
                    param: 'P_CONTROLE_PARCELA',
                    string: " and cp.id_situacao in('1','4','6')  and  cp.id in ('" + idGerado + "')",
                  },
                ]).then(
                  () => {
                    this.processando(false);
                  },
                  (error) => {
                    this.processando(false);
                    this.$root.$emit('alert:warn', 'Erro ao exibir a visualização!');
                    console.log(error);
                  },
                );
              },
              (error) => {
                this.processando(false);
                this.$root.$emit('alert:warn', 'Erro ao processar PIX!');
                console.log(error);
              }
            );
          },
          (error) => {
            this.processando(false);
            this.$root.$emit('alert:warn', 'Erro ao atualizar Vencimento!');
            console.log(error);
          },
        );
    },
    consultarPagamentoPixDamAvulso() {
      this.processando(true);
      NotaFiscalAvulsaService.consultarPagamentoPix(this.idNotaAvulsaSelecionada).then(
        (response) => {
          let retorno = response.data;
          if (retorno) {
            this.$root.$emit('alert:sucess', 'Pagamento recebido!');
          } else {
            this.$root.$emit('alert:warn', 'Pagamento não recebido!');
          }
          this.processando(false);
        },
        (error) => {
          this.processando(false);
          this.$root.$emit('alert:warn', 'Erro ao consultar PIX!');
          console.log(error);
        }
      );
    },
    impressaoBoletos(id, pago) {
      console.log(pago);
      this.processando(true);
      this.idDeclaracaoSelecionada = id;
      DeclaracaoService.competenciaDamEmFiscalizacao(this.idDeclaracaoSelecionada)
        .then((responseFisc) => {
          console.log(responseFisc);
          if (responseFisc.data === 'S') {
            this.$root.$emit(
              "alert:warn",
              "Não sera possível a Imppressão do Boleto, Contribuinte em processo de Fiscalização para um dos períodos do DAM!"
            );
            this.processando(false);
            return;
          }
          DeclaracaoService.findBoletos(id)
            .then((response) => {
              this.listBoletos = response.data;
            })
            .then(() => {
              this.showImpressaoBoletos = true;

              this.displayBoletos = true;
              this.processando(false);
            });
        })
    },
    impressaoBoletosDam(declaracao) {
      this.processando(true);
      // Extrair o id_nota_fiscal removendo o prefixo 'DAM_'
      let idNotaAvulsa = declaracao.id.replace('DAM_', '');
      let dataVencimento = new Date();

      NotaFiscalAvulsaService.atualizarVencimento(idNotaAvulsa, dataVencimento)
        .then(
          (response) => {
            let idGerado = response.data;
            ReportService.imprimir('trb_dam_a5', [
              {
                param: 'RP_ID_CLIENTE',
                string: this.currentUser.usuario.idCliente,
              },
              {
                param: 'P_CONTROLE_PARCELA',
                string: " and cp.id_situacao in('1','4','6')  and  cp.id in ('" + idGerado + "')",
              },
            ]).then(
              () => {},
              (error) => {
                this.$root.$emit('alert:warn', 'Erro ao exibir a visualização do DAM!');
                console.log(error);
              }
            );
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao preparar a impressão do DAM!');
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    hideBoletos() {
      this.displayBoletos = false;
    },
    hideItensDecbeneficio() {
      this.displayItensDecBeneficio = false;
    },
    escolhaPagamentoPix(idDamAgrupamento, tipoDam, dataVencimento) {
      this.idDamAgrupamento = idDamAgrupamento;
      this.tipoDam = tipoDam;
      this.dataVencimento = dataVencimento;
      this.showEscolhaPix = true;
    },
    criarPagamentoPix() {
      this.processando(true);
      this.showEscolhaPix = false;
      DeclaracaoService.criarPagamentoPix(
        this.idDamAgrupamento,
        this.idDeclaracaoSelecionada
      )
        .then(
          (response) => {
            console.log(response);
            this.pixGerado = response.data;
            this.optionsPix.data = this.pixGerado.qrCode;
            this.showPix = true;
          },
          (error) => {
            this.pixGerado = null;
            this.$root.$emit("alert:warn", error);
            console.log(error);
          }
        )
        .then(() => {
          this.showEscolhaPix = false;
          this.processando(false);
        });
    },
    carregarVencimentoBoleto(id, tipo, dataVencimento, tipoEmissao) {
      this.tipoEmissaoBoleto = tipoEmissao;
      this.showEscolhaPix = false;
      let d = dataVencimento.split("-");
      this.tipoDam = tipo;
      if (this.tipoDam === "A") {
        this.idDamAgrupamento = id;
      } else {
        this.idDecLancamentoSelecionado = id;
      }
      this.dataVencimento = new Date(d[0], d[1] - 1, d[2]);
      this.displayVencBoleto = true;
    },
    hideVencBoleto() {
      this.displayVencBoleto = false;
      this.idDecLancamentoSelecionado = null;
      this.idDamAgrupamento = null;
    },
    imprimirBoleto() {
      if (!this.dataVencimento) {
        this.$root.$emit("alert:warn", "Data de Vencimento Obrigatória!");
        return;
      }
      this.processando(true);
      var novaData = new Date();
      if (novaData > this.dataVencimento) {
        this.dataVencimento = novaData;
      }
      DeclaracaoService.atualizarParcelaDam(
        this.tipoDam,
        this.idDamAgrupamento,
        this.idDeclaracaoSelecionada,
        this.dataVencimento,
        this.currentUser.usuario.idUsuario
      )
        .then(
          (response) => {
            console.log(response);
            let idGerado = response.data;
            ReportService.imprimir("trb_dam_a5", [
              {
                param: "RP_ID_CLIENTE",
                string: this.currentUser.usuario.idCliente,
              },
              {
                param: "P_CONTROLE_PARCELA",
                string:
                  " and cp.id_situacao in('1','4','6')  and  cp.id in ('" +
                  idGerado +
                  "')",
              },
            ]).then(
              (data) => {
                console.log(data);
              },
              (error) => {
                this.$root.$emit(
                  "alert:warn",
                  "Erro ao exibir a visualização!"
                );
                console.log(error);
              }
            );
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao atualizar Vencimento!");
            console.log(error);
          }
        )
        .then(() => {
          this.hideVencBoleto();
          this.hideBoletos();
          this.processando(false);
        });
    },
    consultarPagamentoPix(idDamAgrupamento) {
      if (idDamAgrupamento) {
        this.processando(true);
        DeclaracaoService.consultarPagamentoPix(
          this.idDeclaracaoSelecionada,
          idDamAgrupamento
        )
          .then(
            (response) => {
              console.log(response);
              this.pesquisar();
              this.hideBoletos();
              this.showPix = false;
              this.$root.$emit("alert:info", response.data);
            },
            (error) => {
              console.log(error);
              this.$root.$emit("alert:warn", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    showNotaDam() {
      this.showPesqNota = true;
    },
    async exportCSVDt1() {
      await DeclaracaoService.getConsultaRelDamXls(this.dataIni, this.dataFim, null, null).then(
        (response) => {
          response.data;
          this.sqlRelatorio = response.data;
        },
        (error) => {
          console.log(error);
        }
      );
      this.imprimirExcel();
    },
    exportCSVDt2() {
      this.$refs.dt2.exportCSV();
    },
    imprimirExcel() {
      this.imprimirConsultaTipo('xls');
    },
    imprimirConsultaTipo(tipo) {
      this.processando(true);
      ReportService.imprimir("ConsultaDamXls", [
        {
          param: "P_CONSULTA",
          string: this.sqlRelatorio
        }
      ], tipo)
        .then(
          () => { },
          error => {
            this.$root.$emit("alert:warn", "Erro ao Imprimir!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    pesquisarDamPorNota() {
      this.processando(true);

      if (!this.dataIni || !this.dataFim) {
        this.$root.$emit(
          "alert:warn",
          "Filtro de Pesquisa de datas inicial e final obrigatório!"
        );
        this.processando(false);
        return;
      } else if (this.numeroNfsePesquisa.trim() === '' && this.filtro.trim() === '') {
        this.$root.$emit(
          "alert:warn",
          "Filtro obrigatório!"
        );
        this.processando(false);
        return;
      }


      DeclaracaoService.findAllDeclaracoesPorPeriodoNumero(
        this.currentUser.contribuinte.idContribuinte,
        this.dataIni,
        this.dataFim,
        this.numeroNfsePesquisa.trim(),
        this.filtro
      ).then((response) => {
        this.listDeclaracao = response.data;
      }).then(() => {
        this.showPesqNota = false;
        this.processando(false);
      });

    },
    imprimirBoletoPix() {
      if (!this.dataVencimento) {
        this.$root.$emit("alert:warn", "Data de Vencimento Obrigatória!");
        return;
      }
      this.processando(true);
      console.log(this.tipoDam);
      DeclaracaoService.atualizaVencimentoBoleto(
        this.tipoDam,
        this.idDamAgrupamento,
        this.idDeclaracaoSelecionada,
        this.dataVencimento
      )
        .then(
          (response) => {
            console.log(response);
            let idGerado = response.data;
            DeclaracaoService.criarPagamentoPixCp(
              idGerado,
              this.idDeclaracaoSelecionada
            )
              .then(
                (response) => {
                  console.log(response);
                  this.pixGerado = response.data;
                  ReportService.imprimir("trb_dam_a5_pix", [
                    {
                      param: "RP_ID_CLIENTE",
                      string: this.currentUser.usuario.idCliente,
                    },
                    {
                      param: "QR_CODE",
                      string: this.pixGerado.qrCode,
                    },
                    {
                      param: "P_CONTROLE_PARCELA",
                      string:
                        " and cp.id_situacao in('1','4','6')  and  cp.id in ('" +
                        idGerado +
                        "')",
                    },
                  ]).then(
                    (data) => {
                      console.log(data);
                    },
                    (error) => {
                      this.$root.$emit(
                        "alert:warn",
                        "Erro ao exibir a visualização!"
                      );
                      console.log(error);
                    }
                  );
                },
                (error) => {
                  this.pixGerado = null;
                  this.$root.$emit("alert:warn", error);
                  console.log(error);
                }
              )
              .then(() => {
                this.showEscolhaPix = false;
                this.processando(false);
              });
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao atualizar Vencimento!");
            console.log(error);
          }
        )
        .then(() => {
          this.hideVencBoleto();
          this.hideBoletos();
          this.processando(false);
        });
    },
    getTotalIss(valor, abatimento, aliquota) {
      if (abatimento > valor) {
        abatimento = valor;
      }
      let val = ((valor - abatimento) * aliquota) / 100;
      if (!val) return "0,00";
      const valueString = val.toFixed(2).replace(".", ",");
      return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatted_string(pad, user_str, pad_pos) {
      if (typeof user_str === "undefined") return pad;
      if (pad_pos == "l") {
        return (pad + user_str).slice(-pad.length);
      } else {
        return (user_str + pad).substring(0, pad.length);
      }
    },
  },
  computed: {
    isBloqueado() {
      return this.currentUser && this.currentUser.idBolBloquearSistema && this.currentUser.idBolBloquearSistema === 'S';
    },
  },
};
</script>

<style lang="scss" scoped>
.white-line {
  color: white;
}

/deep/ .green-row {
  background-color: #28a745 !important;
}

/deep/ .red-row {
  background-color: #fd7272 !important;
}

textarea {
  width: 100%;
  border-radius: 12Px;
}

.subtitle {
  margin-left: 55px;
  font-size: 14px;
  opacity: 0.8;
}

.custom-input {
  width: 80%;
  text-align: center;
  padding: 12px;
  border-radius: 12px;
  font-size: 16px;
  background-color: #f4f6f9;
  border: 1px solid #dcdcdc;
}
</style>